const style = {
  wrapper: {
    marginBottom: `25px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Support/style/top.js